import React, { useContext } from "react";
import { swiggyIMageCDN } from "../../constant";
import info1 from "../utils/userContext";

const RestrauntCard = (props) => {
  const { user } = useContext(info1);
  return (
    <div>
      <div id="shadow" className="w-[250px] h-[320px] m-4 p-3 rounded-xl">
        <img
          className="h-[160px] w-72 rounded-2xl"
          src={swiggyIMageCDN + props.cloudinaryImageId}
        />
        <h2 className="font-bold text-lg">{props.name}</h2>
        <h4 className="text-sm">{props.cuisines?.join(" ")}</h4>
        <div className="bg-LightGreen rounded-lg w-fit p-2 mt-2 text-Secondry flex justify-center items-center text-sm">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-star"
          >
            <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
          </svg>
          <span className="pl-1">{props.avgRating}</span>
        </div>
      </div>
    </div>
  );
};

export default RestrauntCard;

/***
 * app.js(props)
 *   <BODY user/>
 *      >restrauntcard.js user/>
 * `      <{user}
 */
